// /src/components/modals/ImovelEditorModal/EditorFooter.jsx
import React from 'react';
import { FiCheckCircle, FiLoader } from 'react-icons/fi';

export const EditorFooter = ({ onClose, isSubmitting }) => (
    <footer className="px-12 py-8 border-t border-[var(--border-color)] flex justify-between items-center bg-[var(--bg-card)]">
        <button 
            type="button" 
            onClick={onClose} 
            className="text-[10px] font-black uppercase tracking-[0.3em] opacity-40 hover:opacity-100 transition-all"
        >
            Abortar Edição
        </button>
        <button 
            type="submit" 
            form="editor-form" 
            disabled={isSubmitting} 
            className="px-16 py-5 rounded-2xl bg-accent text-black font-black uppercase text-xs shadow-2xl flex items-center gap-4 transition-all hover:scale-105 active:scale-95 disabled:opacity-50 tracking-[0.3em]"
        >
            {isSubmitting ? <FiLoader className="animate-spin" /> : <FiCheckCircle size={20} />} 
            Salvar Alterações
        </button>
    </footer>
);